// extracted by mini-css-extract-plugin
export var inlineLink = "_ad-0";
export var inlineLinkButton = "_ad-1";